const isInt = (n) => n % 1 === 0;

export default isInt;
